import type { IconData } from '@stacksjs/iconify-core'

export const travelWayfindingBalloon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.905 6.09h1.52v10.67h-1.52Zm-1.52 10.67h1.52v3.05h-1.52Zm0-13.71h1.52v3.04h-1.52Zm-1.53 16.76h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Zm0-19.81h3.05v1.53h-3.05Zm-1.53 6.1h1.53v10.66h-1.53Zm0 10.66h-1.52v4.58h-4.57v-4.58h-1.53v4.58h-1.52v1.52h1.52v3.05h-1.52v3.05h1.52V32h7.62v-1.52h1.53v-3.05h-1.53v-3.05h1.53v-1.52h-1.53Zm-1.52 9.15h-4.57v-3.05h4.57Zm-6.1-19.81h1.53v-6.1h4.57v6.1h1.52v-6.1h1.53V0h-10.67v1.52h1.52zm-1.52 0h1.52v10.66h-1.52Zm-1.52 13.71h1.52v1.53h-1.52ZM7.615 1.52h3.05v1.53h-3.05Zm0 18.29h1.53v1.52h-1.53Z\"/><path fill=\"currentColor\" d=\"M6.095 16.76h1.52v3.05h-1.52Zm0-13.71h1.52v3.04h-1.52Zm-1.52 3.04h1.52v10.67h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default travelWayfindingBalloon
